import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';
import { Button } from '../button/Button';
import './DataGroup.scss';

// #region Component Props

interface IProps {
    title                   : string;
    actionText?             : string;
    actionClick?            : any;
    actionIcon?             : string;
    requiredPermissions?    : Permissions[];
    disabled                : boolean;
}

// #endregion

const DataGroupHeader = (props: IProps) => (
    <h2 className={'datagroup-header ' + (props.actionClick ? '' : '') }>
        { props.title }
        {
            props.actionClick && props.actionText && !props.disabled
            ? <HasPermission requiredPermissions={ props.requiredPermissions ? props.requiredPermissions : []}>
                <Button
                    classes=""
                    testID="data-group-header-action"
                    text={ props.actionText }
                    onBtnClick={ props.actionClick }
                    icon={ props.actionIcon }
                    />
                </HasPermission>
            : null
        }
    </h2>
);

DataGroupHeader.defaultProps = {
    actionText: undefined,
    actionClick: undefined,
    actionIcon: undefined,
    disabled: false
};

export { DataGroupHeader };
